<template>
  <section class="tw:h-screen tw:w-screen tw:flex tw:justify-center tw:items-center">Redirecting...</section>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { useSessionValues } from '@/composables/useSessionValues'

const store = useStore()
const { language } = useSessionValues()

/**
 * Redirect to signup flow before component mounts
 */
onBeforeMount(() => {
  store.dispatch('session/authorize', {
    type: 'signup',
    locale: language.value,
  })
})
</script>
